import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function Redirection() {
    const location = useLocation();

    useEffect(() => {
        const detectClient = (): 'ios' | 'android' | 'other' => {
            const userAgent = navigator.userAgent.toLowerCase();

            if (/iphone|ipad|ipod/.test(userAgent)) {
                return 'ios';
            }
            if (/android/.test(userAgent)) {
                return 'android';
            }
            return 'other';
        };

        const redirectToStore = () => {
            const client = detectClient();

            const stores = {
                ios: 'https://apps.apple.com/ru/app/looking-ai/id6742911691',
                android: 'https://play.google.com/store/apps/details?id=com.looking_ai.mobile',
                other: 'https://looking-ai.com'
            };

            window.location.href = stores[client];
        };

        redirectToStore();
    }, [location]);

    return null;
}